const SDK_VERSION = '7.116.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
